// extracted by mini-css-extract-plugin
export default {"wrapper":"qP3IB8","expandIcon":"swD3Cy"};